/**
 * Digi-Cute-Palette — Pastell-Rosa/Lavendel/Minze-Osterei-Theme.
 * Ordnet primitive Cute-Tokens denselben semantischen Palette-Slots zu,
 * die auch Light- und Dark-Paletten verwenden, damit alle Komponenten
 * ohne Anpassungen funktionieren.
 */

import {PaletteOptions} from '@mui/material/styles';

import {cute, overlay} from './customColors';

export const digiCutePalette: PaletteOptions = {
  // ─── MUI Standard Palette ───────────────────────────────────────────────────

  mode: 'light',
  common: {
    black: cute.textPrimary,
    white: cute.white,
  },
  primary: {
    main: cute.pinkMid,
    light: cute.pink,
    dark: cute.pinkDark,
    contrastText: cute.white,
  },
  secondary: {
    main: cute.lavenderLight,
    light: cute.pinkLight,
    dark: cute.pink,
    contrastText: cute.textPrimary,
  },
  warning: {
    main: cute.peach,
    light: cute.peachLight,
    dark: cute.peachDark,
  },
  error: {
    main: cute.blush,
    light: cute.blushLight,
    dark: cute.blushDark,
  },
  success: {
    main: cute.mint,
    light: cute.mintLight,
    dark: cute.mintDark,
    contrastText: cute.textPrimary,
  },
  info: {
    main: cute.sky,
    light: cute.skyLight,
    dark: cute.skyDark,
  },
  background: {
    default: 'transparent',
    paper: cute.whitePaper,
  },
  text: {
    primary: cute.textPrimary,
    secondary: cute.textSecondary,
  },
  divider: cute.border,

  // ─── Custom Palette Extensions ──────────────────────────────────────────────

  misc: {
    main: cute.lavenderLight,
    light: cute.pinkLight,
    dark: cute.textSecondary,
    contrastText: cute.textPrimary,
  },
  pending: {
    main: cute.sky,
    light: cute.skyLight,
    dark: cute.skyDark,
    contrastText: cute.textPrimary,
  },
  loginPage: {
    background: cute.loginGradient,
    formBoxBackground: cute.loginFormBox,
    topBannerBackground: cute.pinkDark,
  },
  app: {
    boxBackground: 'transparent',
    boxBorder: 'transparent',
    basketBadgeBackground: cute.lavender,
  },
  basketPopover: {
    customPopover: cute.cardAlpha,
    itemCardBackground: cute.lavenderAlpha60,
    deleteBasketText: cute.textPrimary,
    deleteBasketTextHover: cute.pinkDark,
  },
  itemCard: {
    cardBackground: cute.cardAlpha,
    imageBoxBackground: cute.pinkAlpha40,
  },
  table: {
    background: cute.lavenderAlpha60,
  },
  tableRow: {
    background: cute.cardAlpha70,
  },
  itemView: {
    paper: cute.cardAlpha80,
  },
  structureMainView: {
    itemBackground: cute.pink,
    paper: cute.cardAlpha80,
  },
  structureTree: {
    customDrawerBackground: 'transparent',
  },
  structureTreeItem: {
    secondaryLabelColor: overlay.black60,
  },
  metadataComponent: {
    paper: cute.cardAlpha,
    tabDisabledText: cute.border,
  },
  fileNameInfo: {
    navButtonColor: cute.pinkDark,
  },
  fileUploadDialog: {
    background: cute.pinkSolid,
    paper: cute.cardAlpha,
    tableBackground: cute.cardAlpha70,
    tableHeaderBackground: cute.lavenderAlpha60,
  },
  appBar: {
    background: 'transparent',
    typography: cute.textPrimary,
  },
  footer: {
    paper: cute.pinkAlpha50,
  },
  sideBar: {
    iconColorActive: cute.pinkDark,
    iconColorInactive: cute.textSecondary,
    typography: cute.textPrimary,
    paper: 'transparent',
    menuPaper: cute.cardAlpha,
  },
  itemStatus: {
    background: cute.lavenderAlpha60,
    hoverBackground: cute.pinkAlpha50,
    menuItemBackground: cute.cardAlpha,
  },
  derivatePanelGroup: {
    cardBackground: cute.cardAlpha,
  },
  userManagement: {
    fontColorSelected: cute.textPrimary,
  },
  customButton: {
    blackColor: cute.textPrimary,
  },
  hero: {
    gradient: `linear-gradient(transparent 50%, ${cute.pink})`,
    searchBar: {
      background: cute.lavenderLight,
      hover: cute.pinkLight,
    },
  },
  imageEditor: {
    preview: {
      backgroundColor: cute.whitePaper,
      backgroundImage:
        `linear-gradient(45deg, ${cute.lavenderLight} 25%, transparent 25%),` +
        `linear-gradient(-45deg, ${cute.lavenderLight} 25%, transparent 25%),` +
        `linear-gradient(45deg, transparent 75%, ${cute.lavenderLight} 75%),` +
        `linear-gradient(-45deg, transparent 75%, ${cute.lavenderLight} 75%)`,
      overlayColor: cute.lavenderAlpha60,
    },
  },
};
